import React from 'react';
import css from './radio.module.scss';
import RadioBase from '@mui/material/Radio';
import clsx from 'clsx';

type Props = {
  label?: string | React.ReactNode;
  name?: string;
  variant?: 'default' | 'button';
} & React.ComponentProps<typeof RadioBase>;

const Radio: React.FC<Props & React.InputHTMLAttributes<any>> = (props) => {
  const { id, label, title, variant = 'default', checked, ...rest } = props;

  return (
    <div
      className={clsx(
        css.root,
        css['checkbox'],
        variant === 'button' && css['variant-button'],
        variant === 'button' && checked && css['variant-button-active'],
      )}
      title={title}
    >
      <RadioBase
        id={id}
        className={clsx(css.radio, variant === 'button' && css['radio-hidden'])}
        checked={checked}
        {...rest}
      />
      {label && (
        <label htmlFor={id} className={css.label}>
          {label}
        </label>
      )}
    </div>
  );
};

export default Radio;
